import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';
import useBookingPush from '../hooks/useBookingPush';

const Layout = () => {
  useBookingPush();
  return (
    <div className="layout">
      <div className="content">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
};

export default Layout;
